import type { AppTranslationsType } from '@/store/types/app'
import useGlobalStore from '@/store/useGlobalStore'
import { useEffect } from 'react'

type Props = {
  translations?: AppTranslationsType
}

// Translations are always gotten from the server, on the server side, and this hook should
// be present in all the pages.

export const useInitTranslations = ({ translations }: Props) => {
  const { setApp } = useGlobalStore()

  // this fix has been made with ❤️
  useEffect(() => {
    if (!translations) return

    setApp({ translations })
  }, [])
}
